import { titleize } from 'inflection';
import { dollarSignify } from 'buyside/util/textHelpers';

export const chunkArray = (arr: any[], chunkSize: number): any[] =>
  arr
    .map((_el, idx) => {
      return idx % chunkSize === 0 ? arr.slice(idx, idx + chunkSize) : null;
    })
    .filter(el => el);

export const labelize = (
  values: string[],
  titleizeLabel?: boolean
): { label: string; value: string }[] =>
  values.map(value => ({
    label: titleizeLabel ? titleize(value) : value,
    value
  }));

export const labelizeWithDollarSign = (values: string[]): { label: string; value: string }[] =>
  values.map(value => ({
    label: dollarSignify(value),
    value: value
  }));

type Truthy<T> = T extends false | '' | null | undefined ? never : T;
export const truthy = <T>(value: T): value is Truthy<T> => !!value;
